<template>

    <div class="layout__container layout__padding-20-0 text__align-center">
        <div class="layout__padding-clear layout__width-800px">
            <StepGuide :stepCount="3"></StepGuide>
        </div>
        <div class="layout__padding-20-0">
            <h2 class="text__colour-teal">Thank you for placing your order with Ravensworth</h2>

            <div class="layout__padding-20-0">
                <p class="text__size-16">Order Reference: RAV{{this.job.id}}</p>
                <p class="text__size-16">User Reference: {{this.job.userReference}}</p>
            </div>
            <div class="">
                <p class="text__size-16">We have sent you an email with the full details of your order.</p>
                <!--<p class="text__size-16">We will shortly send your invoice within a maximum of 31 days.</p>-->
                <p class="text__size-16" v-if="JSON.parse(this.returnCookie('_role')).includes('AccountCustomer')">Invoices are issued at the beginning of the month. Payment terms are 30 days.</p>
            </div>

            <div class="layout__padding-20-0">
                <p class="text__size-16">You can also view your order by clicking on the button below.</p>
            </div>
            <el-button class="button-teal button__base layout__width-200px" v-on:click="confirmation()">View my orders
            </el-button>

        </div>
    </div>

</template>

<script>
    import Router from '../../../router';
    import {mapGetters, mapActions} from 'vuex';
    import {axios} from '@/mixins/Axios.js';
    import StepGuide from "../../../components/tools/photofixr/StepGuide.vue";

    export default {
        name: "confirmation",
        mixins: [axios],
        props: ['job'],
        components: {
            StepGuide
        },
        created() {

            window.sessionStorage.removeItem("_fixes");
            window.sessionStorage.removeItem("_jobId");
            window.sessionStorage.removeItem("_errors");


            const basketTotals = {
                photofixr: 0
            }
            this.$store.dispatch("incrementPhotofixrTotal", basketTotals)

        },
        methods: {
            ...mapActions([
                'wipePhotofixrTotal'
            ]),
            confirmation() {
                Router.push({
                    name: '/orders/photofixr'
                });
            }
        }
    };
</script>